import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../api/config';
import {
  JourneyEducationalContent,
  EducationalVideosResponse,
} from './EducationModel';
import { education } from '../../api/Endpoints';

export const useGetJourneyEducationalContent = (placeHolder: string) => {
  return useQuery<JourneyEducationalContent, Error>({
    queryKey: [QUERY_KEYS.NUTRITION_EDUCATIONAL_CONTENT, placeHolder],
    queryFn: async () => {
      const response = await education.getEducationContent(placeHolder);
      return response.data;
    },
  });
};

export const useGetEducationalVideoList = (placeHolder: string) => {
  return useQuery<EducationalVideosResponse, Error>({
    queryKey: [QUERY_KEYS.EDUCATION_VIDEOS, placeHolder],
    queryFn: async () => {
      const response = await education.getEducationalVideos(placeHolder);
      return response.data;
    },
  });
};
